import { appendSearchParams } from '@mopla/utils';

/** The new app always asks for the Stripe configuration that includes Pay by Bank; old app versions never send the parameter. */
export const SETUP_INTENT_URL = '/api/passengers/intent?payByBank=supported';

/**
 * Builds the native deep link the payment app navigates to after Stripe's redirect.
 * Returns null when there is nothing to forward (no setup intent / status) or the setup failed.
 */
export const buildPaymentAppCloseCallbackUrl = (
	closeCallback: string,
	query: URLSearchParams
): string | null => {
	const setupIntentId = query.get('setup_intent');
	const redirectStatus = query.get('redirect_status');

	if (!setupIntentId || !redirectStatus || redirectStatus === 'failed') {
		return null;
	}

	return appendSearchParams(closeCallback, {
		setup_intent: setupIntentId,
		redirect_status: redirectStatus,
	});
};
